import { useEffect } from 'react';
import { useCookie } from '@/providers/Cookie/useCookie';
import { trackingService } from './tracking-service';

/**
 * Hook to initialize and sync tracking service with cookie consents
 * Automatically updates tracking when cookie preferences change.
 *
 * Each tracker is responsible for its own setup (e.g. GtmTracker pushes
 * Consent Mode defaults before loading the GTM container).
 */
export function useTracking(): void {
  const { preferences } = useCookie();

  useEffect(() => {
    trackingService.init();
  }, []);

  useEffect(() => {
    trackingService.syncConsents(preferences);
  }, [preferences]);
}
